/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { PhoneCallStepOverrideTaskNoteDoc } from './phoneCallStepOverrideTaskNoteDoc';

export interface PhoneCallStepOverride {
  type: 'phone_call';
  task_note_doc?: PhoneCallStepOverrideTaskNoteDoc;
}
